<template>
  <el-dialog
      title="ACR Cloud Data"
      :visible="acr_cloud_data_dialog"
      :modal="true"
      width="70%"
      top="3vh"
      @close="close"
      :append-to-body="true"
  >
    <h4 style="text-align: center"> Music Data </h4>
    <el-table :data="music" style="width: 100%">
      <el-table-column prop="label" label="Label" align="center"></el-table-column>
      <el-table-column prop="isrc" label="ISRC" align="center"></el-table-column>
      <el-table-column prop="upc" label="UPC" align="center"></el-table-column>
      <el-table-column prop="score" label="Score" align="center"></el-table-column>
      <el-table-column prop="release_date" label="Release Date" align="center"></el-table-column>
      <el-table-column label="Artists" align="center">
        <template slot-scope="props">
          <ul>
            <li v-for="artist in props.row.artists"> {{ artist }} </li>
          </ul>
        </template>
      </el-table-column>
    </el-table>
    <h4 style="text-align: center">Metadata</h4>
    <el-table :data="metadata" style="width: 100%">
      <el-table-column label="Cover" align="center">
        <template slot-scope="props">
          <img :src="props.row.image" alt="cover_image" class="avatar">
        </template>
      </el-table-column>
      <el-table-column label="Deezer" align="center">
        <template slot-scope="props">
          <ul v-if="props.row.links.deezer">
            <li v-for="(link, index) in props.row.links.deezer">
              <a :href="link" target="_blank" rel="noreferrer noopener nofollow"> {{ 'Link' + (index + 1) }} </a>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="Spotify" align="center">
        <template slot-scope="props">
          <ul v-if="props.row.links.spotify">
            <li v-for="(link, index) in props.row.links.spotify">
              <a :href="link" target="_blank" rel="noreferrer noopener nofollow"> {{ 'Link' + (index + 1) }} </a>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="Apple Music" align="center">
        <template slot-scope="props">
          <ul v-if="props.row.links.applemusic">
            <li v-for="(link, index) in props.row.links.applemusic">
              <a :href="link" target="_blank" rel="noreferrer noopener nofollow"> {{ 'Link' + (index + 1) }} </a>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="YouTube" align="center">
        <template slot-scope="props">
          <ul v-if="props.row.links.youtube">
            <li v-for="(link, index) in props.row.links.youtube">
              <a :href="link" target="_blank" rel="noreferrer noopener nofollow"> {{ 'Link' + (index + 1) }} </a>
            </li>
          </ul>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState('trackImport', ['acr_cloud_data_dialog', 'track']),

    music() {
      if (this.track.acr_cloud_data) {
        return this.track.acr_cloud_data.music
            ? this.track.acr_cloud_data.music
            : []
      }
      return []
    },

    metadata() {
      if (this.track.acr_cloud_data) {
        return this.track.acr_cloud_data.metadata
            ? this.track.acr_cloud_data.metadata
            : []
      }
      return []
    }
  },

  methods: {
    ...mapMutations('trackImport', ['setAcrCloudDataDialog', 'setTrack']),

    close() {
      this.setAcrCloudDataDialog(false)
      this.setTrack({})
    }
  }
}
</script>

<style scoped lang="scss">

</style>